import axios from 'axios'

import { getApiBaseURL } from './environment'
import { xFestivalName } from '../constants/baseUrls'

export const http = axios.create({
  baseURL: `${getApiBaseURL()}/`,
})

export const httpPublic = axios.create({
  baseURL: `${getApiBaseURL()}/`,
})

http.defaults.headers.common['x-festival-name'] = xFestivalName.value
